<template>
  <div class="box">
    <div class="title fs15">
      <p>企业在线注册</p>
    </div>
    <div class="main">
      <h3 class="fs18 mb20">新用户注册</h3>
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入企业统一信用代码"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="mob">
            <el-input v-model="ruleForm.mob" placeholder="请输入手机号码"></el-input>
          </el-form-item> -->
          <!-- <el-form-item prop="code" class="code">
            <el-input v-model="ruleForm.code" autocomplete="off" placeholder="请输入短信验证码"></el-input>
            <el-button v-if="disabled == false" type="button" class="btn" :disabled="disabled" @click="sendcode">发送验证码</el-button>
            <el-button v-if="disabled == true" type="button" class="btn" :disabled="disabled" @click="sendcode">{{ btntxt }}</el-button>
          </el-form-item> -->
          <el-form-item prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="new-password" placeholder="设置6至20位登录密码"></el-input>
          </el-form-item>
          <el-form-item prop="sure_pwd">
            <el-input type="password" v-model="ruleForm.sure_pwd" placeholder="请再次输入登录密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="ruleForm.checked">
              勾选同意
              <span class="agreement">《用户服务协议》</span>
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
          </el-form-item>
          <el-form-item>
            已有账号,
            <router-link to="/login" class="login">立即登录</router-link>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validPhone,validUscc } from "@/assets/js/validate";
import Cookies from "js-cookie";

let validPwd = function(rule, value, callback) {
  if (!value) {
    callback(new Error("请再次输入登录密码"));
  } else if (this.ruleForm.password !== value) {
    callback(new Error("请保证两次登录密码一致"));
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        // mob: "",
        code: "",
        password: "",
        sure_pwd: "",
        checked: true
      },
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      rules: {
        name: [{ required: true, trigger: "blur", validator: validUscc }],
        // mob: [{ required: true, trigger: "blur", validator: validPhone }],
        // code: [{ required: true, message: "请输入短信验证码" }],
        password: [
          { required: true, message: "请输入登录密码" },
          { min: 6, max: 20, message: "设置6至20位登录密码" }
        ],
        sure_pwd: [
          {
            required: true,
            trigger: "blur",
            validator: validPwd.bind(this)
          }
        ]
      }
    };
  },
  created() {
    // this.register()
  },
  methods: {
    async register() {
      // 这里用try catch包裹，请求失败的时候就执行catch里的
      try {
        //定义参数对象
        let params = {
          name: this.ruleForm.name,
          mob: this.ruleForm.name,
          // code: this.ruleForm.code,
          code: this.randomCode(),
          password: this.ruleForm.password
        };
        let res = await this.$api.account.register(params);
        console.log("​注册 -> res", res);
        if (res.code === 0) {
          this.$message({
            message: "注册成功,请补充相关信息",
            type: "success",
            center: true
          });
          localStorage.setItem("token", res.data.id);
          localStorage.setItem("id", "");
          // localStorage.setItem("id", res.data.id);
          Cookies.set("token", `enterpriseSession_${res.data.id}`);
          // setCookie("token", `enterprise_session:${res.data.id}`)
          this.$emit("changeActive");
        } 
      } catch (e) {
        console.log("​catch -> e", e);
      }
    },
    randomCode() {
      const len = Math.floor(Math.random() * 3) + 4; // 4~6位
      const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@#$%^&*";
      let code = "";
      for (let i = 0; i < len; i++) {
        code += chars[Math.floor(Math.random() * chars.length)];
      }
      return code;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.register();
          // if (this.active++ > 3) this.active = 0;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //手机验证发送验证码
    sendcode() {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.ruleForm.mob == "") {
        this.$message({
          message: "手机号不能为空",
          center: true
        });
        return;
      }
      if (!reg.test(this.ruleForm.mob)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true
        });
        return;
      } else {
        let params = {
          phone: this.ruleForm.mob,
          type: "enterprise"
        };
        this.$api.common.sendCode(params).then(res => {
          if (res.code === 0) {
            this.$message({
              message: "发送成功",
              type: "success",
              center: true
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          }
        });
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  margin: 0 auto;
  border: 1px solid #e9e9e9;
  width: 540px;
  color: #999999;
  .title {
    width: 540px;
    height: 50px;
    font-weight: 700;
    line-height: 28px;
    border-bottom: 1px solid #e9e9e9;
    background: #fff;
    p {
      height: 100%;
      line-height: 50px;
      padding-left: 20px;
    }
  }
  .main {
    text-align: center;
    margin: 0 auto;
    padding: 30px 0;
    background: #fff;
    h3 {
      color: #333;
      font-weight: bold;
    }
    .form {
      width: 100%;
      .el-form-item {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
      }
      .code {
        position: relative;
        .btn {
          position: absolute;
          right: 0;
        }
      }
      .el-button--primary {
        width: 100%;
      }
      .login {
        color: #409eff;
      }
    }
  }
}
</style>